import { Stack, Typography } from '@mui/material'
import { useMemo } from 'react'
import { Icons } from 'utoniq-ui'

type RankProps = {
  rank?: number
}

export const Rank = ({ rank }: RankProps) => {
  const color = useMemo(() => {
    switch (rank) {
      case 1:
        return 'primary.main'
      case 2:
        return 'grey.700'
      case 3:
        return 'grey.200'
    }
  }, [rank])

  return (
    <Stack alignItems="center" sx={{ width: 40 }}>
      {rank && rank <= 3 && <Icons.Rank fontSize="medium" sx={{ color }} />}
      <Typography variant="subtitle1">{rank}</Typography>
    </Stack>
  )
}
